import React, { memo } from 'react';
import type { RouterHistory } from '@core/shared';
import WorkspaceForm from './WorkspaceForm';
import WorkspaceWrapper from './WorkspaceWrapper';
import '../../styles/_login.scss';

type Props = {
  getOrganisationNameFromAlias: any;
  history: RouterHistory;
};

const Workspace = ({ getOrganisationNameFromAlias, history }: Props) => (
  <WorkspaceWrapper backgroundType="person">
    <WorkspaceForm
      history={history}
      getOrganisationNameFromAlias={getOrganisationNameFromAlias}
    />
  </WorkspaceWrapper>
);

export default memo<Props>(Workspace);
